import React, { useEffect, useState } from "react";
import MainCard from '@/components/MainCard';
import TableContainer from '@/components/TableContainer';
import ColConfigPortal from './ColConfigPortal';
import {
  Steps,
  Descriptions,
  Table,
  Empty,
  Flex,
  ConfigProvider,
  Modal,
  Input,
  Grid,
  Timeline,
  Typography as Typography1,
  Popconfirm,
  Card,
  Tag,
  Tooltip,
  Button,
  Space,
} from "antd";
// Ant Design components are used instead of MUI
import { ClockCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { Eye, CheckCircle, XCircle } from 'lucide-react';
import { defaultColors } from '@/themes/antd-theme';
import {
  get_batch_recipe_approval,
  get_api_function,
  update_batch_recipe_approval_status,
} from '@/utils/api';
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import ReusableSearchInput from '@/components/ReusableSearch';
import useTableConfig from '@/hooks/useTableConfig';
import TableColumnConfig from '@/components/TableColumnConfig';
import { useTheme } from '@/App';
import Icons from '@/components/third-party/Icons';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '@/utils/datetime';

// Component aliases for MUI compatibility
const Stack = Space;
const { Title } = Typography1;
const BatchRecipeApproval = ({ searchvalue, isActiveTab }) => {
  const { t } = useTranslation();
  const { isDark } = useTheme();
  const textColor = isDark ? '#ffffff' : '#1f2937';
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comment, set_comment] = useState("");
  const [role, set_role] = useState("");
  const [recipe_data, set_recipe_data] = useState([]);
  const [loading, set_loading] = useState(false);
  const [isAdmin, set_isAdmin] = useState(false);
  const selectedModule = useSelector((state) => state.moduleView);

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  //########## Handle Api's ##############################
  const get_batch_recipe_approval_list = async () => {
    try {
      set_loading(true);
      await get_batch_recipe_approval(success_recipe_data);
    } catch (error) {
      set_loading(false);
      console.error("Error fetching data:", error);
    }
  };

  const success_recipe_data = (res) => {
    set_loading(false);
    set_recipe_data(res?.data?.data || []);
    set_isAdmin(res?.data?.approval_button);
  };

  const success = async (res) => {
    if (res.status === "success") {
      toast.success(res.message);
      try {
        await get_batch_recipe_approval_list(success_recipe_data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else if (res.status === "failed") {
      toast.warning(res.message);
    }
  };

  useEffect(() => {
    get_batch_recipe_approval_list();
  }, []);

  //   const warning = (record) => {
  //     let com = "";
  //     Modal.warning({
  //       title: "Comment",
  //       cancelText: "Cancel",
  //       closable: true,
  //       maskClosable: true,
  //       content: (
  //         <Input
  //           placeholder="Enter Comment"
  //           onChange={(e) => {
  //             com = e.target.value;
  //           }}
  //         />
  //       ),

  //       onOk() {
  //         bp_update_approval_status_for_recipe(
  //           {
  //             comment: com,
  //             process_id: record?.process_id,
  //             batch_number: record?.batch_number,
  //             batch_approval_id: record?.batch_approval_id,
  //             approval_status: false,
  //           },
  //           success
  //         );
  //       },
  //     });
  //   };

  const [approvalStatusData, setApprovalStatusData] = useState([]);

  const allColumns = [
    {
      title: "Batch Number",
      dataIndex: "batch_number",
      key: "batch_number",
      defaultVisible: true,
      sortable: true,
      sortType: "string",
      width: "35%",
    },
    {
      title: "MBMR Name",
      dataIndex: "recipe_name",
      key: "recipe_name",
      defaultVisible: true,
      sortable: true,
      sortType: "string",
      width: "35%",
    },
    //batch_number
    {
      title: "View Approvals",
      key: "view_approvals",
      align: "center",
      defaultVisible: true,
      sortable: false,
      width: "15%",
      render: (_, record) => {
        return (
          <Tooltip title="View">
            <Button
              type="text"
              icon={<Eye size={20} style={{ color: defaultColors.primary }} />}
              onClick={() => {
                setIsModalOpen(true);
                set_role(record?.role_name);
                get_api_function(
                  `/get_batch_recipe_approval_flow?recipe_id=${record?.recipe_id}&batch_number=${record?.batch_number}`,
                  (res) => {
                    if (res.data.status === "success")
                      setApprovalStatusData(res?.data?.data);
                  }
                );
              }}
            />
          </Tooltip>
        );
      },
    },
    isAdmin && {
      title: "Action",
      key: "action",
      align: "center",
      defaultVisible: true,
      sortable: false,
      width: "15%",
      render: (_, record) => {
        return (
          <Stack direction="row" spacing={2} justifyContent="center">
            <Popconfirm
              title="Are you sure you wants to approve this Batch?"
              onConfirm={() => {
                update_batch_recipe_approval_status(
                  {
                    batch_recipe_approval_id: record?.batch_recipe_approval_id,
                    recipe_id: record?.recipe_id,
                    batch_approval_status: "approved",
                    batch_number: record?.batch_number,
                  },
                  success
                );
              }}
              okText="Yes"
              cancelText="No"
              okButtonProps={{
                className:
                  "bg-blue-600 text-white hover:bg-blue-700 border-none",
              }}
              cancelButtonProps={{
                className:
                  "bg-blue-600 text-white hover:bg-blue-700 border-none",
              }}
            >
              <Tooltip title="Approve">
                <Button type="text" icon={<CheckCircle className="w-5 h-5" style={{ color: defaultColors.success }} />} />
              </Tooltip>
            </Popconfirm>
            <Popconfirm
              title="Are you sure you wants to Reject this Batch?"
              onConfirm={() => {
                update_batch_recipe_approval_status(
                  {
                    batch_recipe_approval_id: record?.batch_recipe_approval_id,
                    recipe_id: record?.recipe_id,
                    batch_approval_status: "reject",
                    batch_number: record?.batch_number,
                  },
                  success
                );
              }}
              okText="Yes"
              cancelText="No"
              okButtonProps={{
                className:
                  "bg-blue-600 text-white hover:bg-blue-700 border-none",
              }}
              cancelButtonProps={{
                className:
                  "bg-blue-600 text-white hover:bg-blue-700 border-none",
              }}
            >
              <Tooltip title="Reject">
                <Button type="text" icon={<XCircle className="w-5 h-5" style={{ color: defaultColors.error }} />} />
              </Tooltip>
            </Popconfirm>
          </Stack>
        );
      },
    },
  ].filter(Boolean);

  const addKeysInFilterDataForCollapse = (filterData) => {
    const updatedFilterList = filterData?.map((item, index) => {
      return {
        ...item,
        key: index.toString(), // Update the key to the index converted to a string
      };
    });
    return updatedFilterList;
  };

  const { visibleColumns, columnConfigMenu, filteredData } = useTableConfig({
    tableKey: "batch_recipe_approval_config",
    columns: allColumns,
    data: addKeysInFilterDataForCollapse(recipe_data),
    searchValue: searchvalue,
  });
  const get_Ingredients = (record) => {
    return (
      <Table
        size="small"
        bordered
        title={() => "Ingredients"}
        dataSource={record?.ingredients}
        columns={[
          {
            title: "Ingredient Name",
            dataIndex: "ingredient_name",
            key: "ingredient_name",
          },
          {
            title: "Condition",
            dataIndex: "conditinal_para",
            key: "conditinal_para",
          },
          {
            title: "Quantity",
            key: "quantity",
            render: (_, record) =>
              `${record?.ingredient_qty}${" "}${record?.unit}`,
          },
        ]}
        pagination={false}
      />
    );
  };

  const get_sampling = (record) => {
    return (
      <Table
        size="small"
        bordered
        title={() => "Sampling"}
        dataSource={record?.sampling}
        columns={[
          {
            title: "Material Inventory Name",
            dataIndex: "material_inventory_name",
            key: "material_inventory_name",
          },
          {
            title: "Testing Type Name",
            dataIndex: "testing_type_name",
            key: "testing_type_name",
          },
          {
            title: "Sample Number",
            dataIndex: "sample_number",
            key: "sample_number",
          },
          {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
            render: (_, record) =>
              `${record?.quantity}${" "}${record?.material_inventory_unit}`,
          },
          {
            title: "Sample Quantity",
            dataIndex: "sample_quantity",
            key: "sample_quantity",
            render: (_, record) =>
              `${record?.sample_quantity}${" "}${
                record?.material_inventory_unit
              }`,
          },
        ]}
        pagination={false}
      />
    );
  };

  const get_Product = (record) => {
    return (
      <p style={{ margin: 0 }}>
        <Table
          size="small"
          bordered
          title={() => "Product"}
          dataSource={record?.products}
          columns={[
            {
              title: "Product Name",
              dataIndex: "product_name",
              key: "product_name",
            },
            {
              title: "value",
              key: "value",
              render: (_, record) => {
                return (
                  record?.value?.length > 0 && (
                    <Flex gap="20px" vertical={true} justify="flex-start">
                      <Table
                        size="small"
                        bordered
                        dataSource={record?.value}
                        columns={[
                          {
                            title: "Container Id",
                            dataIndex: "container_id",
                            key: "created_on",
                          },
                          {
                            title: "Tare Wt",
                            dataIndex: "tare_weight",
                            key: "value",
                          },
                          {
                            title: "Gross Wt",
                            dataIndex: "gross_weight",
                            key: "value",
                          },
                          {
                            title: "Net Wt",
                            dataIndex: "net_weight",
                            key: "value",
                          },
                        ]}
                        pagination={false}
                      />
                    </Flex>
                  )
                );
              },
            },
          ]}
          pagination={false}
        />
      </p>
    );
  };

  const get_Parmeters = (record) => {
    return (
      <Table
        size="small"
        bordered
        title={() => "Parameters"}
        dataSource={record?.paramaters}
        columns={[
          {
            title: "Parameter Name",
            dataIndex: "parameter_name",
            key: "parameter_name",
          },
          {
            title: "value",
            key: "value",
            render: (_, record) => {
              return (
                record?.value?.length > 0 && (
                  <Table
                    size="small"
                    bordered
                    dataSource={record?.value}
                    columns={[
                      {
                        title: "Created On",
                        dataIndex: "created_on",
                        key: "created_on",
                        render: (created_on) => (created_on ? formatDateTime(created_on) : '-'),
                      },
                      {
                        title: "Value",
                        dataIndex: "value",
                        key: "value",
                      },
                    ].filter(Boolean)}
                    pagination={false}
                  />
                )
              );
            },
          },
        ]}
        pagination={false}
      />
    );
  };

  const columns = [
    {
      title: "Op No",
      dataIndex: "operation_number",
      key: "operation_number",
    },
    {
      title: "Operation",
      dataIndex: "operation_type",
      key: "operation_type",
    },
    {
      title: "Machine",
      dataIndex: "machine_name",
      key: "machine_id",
    },
    // {
    //   title: "Instruction",
    //   dataIndex: "instruction",
    //   key: "instruction",
    // },
    {
      title: "Total Duration",
      dataIndex: "total_duration",
      key: "total_duration",
      render: (_, record) => {
        return record?.total_duration;
        // <Descriptions
        //   size="small"
        //   column={1}
        //   bordered
        //   items={[
        //     {
        //       key: 0,
        //       label: "Min",
        //       children: record?.min_duration,
        //     },
        //     {
        //       key: 1,
        //       label: "Max",
        //       children: record?.max_duration,
        //     },
        //     {
        //       key: 2,
        //       label: "Total",
        //       children: record?.total_duration,
        //     },
        //   ]}
        // />
      },
    },
    {
      title: "Details ",
      key: "detailsRemarks",
      align: "left",
      render: (_, record) => {
        return (
          <Flex gap="20px" vertical={true} justify="flex-start">
            {record?.ingredients?.length > 0 && get_Ingredients(record)}
            {record?.paramaters?.length > 0 && get_Parmeters(record)}
            {record?.products?.length > 0 && get_Product(record)}
            {record?.sampling?.length > 0 && get_sampling(record)}
          </Flex>
        );
      },
    },
  ];

  const expandableRowRender = (record) => {
    return (
      <p style={{ margin: 0 }}>
        <Table
          dataSource={record?.operations}
          columns={columns}
          pagination={false}
          scroll={{ x: "max-content" }}
          bordered
        />
      </p>
    );
  };

  const approval_status_json = {
    approve: (
      <CheckCircleOutlined style={{ color: "#5DCC79", fontSize: "16px" }} />
    ),
    pending: (
      <ClockCircleOutlined style={{ color: "#FAAE2F", fontSize: "16px" }} />
    ),
    reject: (
      <ClockCircleOutlined style={{ color: "#ff0000", fontSize: "16px" }} />
    ),
  };

  const status_tag_json = {
    approve: <Tag color="success">Approved</Tag>,
    pending: <Tag color="warning">Pending</Tag>,
    reject: <Tag color="warning">Pending</Tag>,
  };

  return (
    <div>
      {/* Column config is portaled up to the parent tab bar (left of the info
          icon) when this tab is active. See #approval-col-cfg in Approvals.js. */}
      <ColConfigPortal active={isActiveTab}>
        <TableColumnConfig menu={columnConfigMenu} />
      </ColConfigPortal>
      {/* Fixed-height, bordered table — same convention as /ticket, /process-library,
          /recipe-approval: tableLayout="fixed" + percentage column widths keep columns
          full-width and stable regardless of row count. */}
      <div
        style={{
          border: '1px solid #e5e7eb',
          borderRadius: 8,
          // overflow: 'visible' (not 'hidden') — 'hidden' clips the table's own
          // horizontal scrollbar at the bottom edge (same bug found on Batch360.js).
          overflow: 'visible',
        }}
      >
        <TableContainer
          columns={visibleColumns}
          bordered
          data={filteredData}
          //  expandable={{ expandedRowRender: expandableRowRender, indentSize: 0 }}
          loading={loading}
          tableLayout="fixed"
          pagination={{
            pageSize: 10,
            pageSizeOptions: ['10', '20', '50', '100'],
          }}
          // Responsive: viewport-anchored so it scales on larger/smaller screens
          height="calc(100vh - 380px)"
          locale={{ emptyText: <Empty description="No recipes found for approval" /> }}
        />
      </div>
      <Modal
        title="Approvals"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
      >
        <Timeline
          mode="alternate"
          items={approvalStatusData?.map((item) => {
            return {
              dot: approval_status_json[item?.approval_status],
              children: (
                <>
                  <Typography1>{item?.role}</Typography1>
                  {status_tag_json[item?.approval_status]}
                </>
              ),
            };
          })}
        />
      </Modal>
    </div>
  );
};

export default BatchRecipeApproval;
